Object.assign = require('object-assign');

module.exports = {
	// Paper
	Paper: require('./components/paper/Paper'),
	// FlexBox
	Container: require('./components/flexbox/Container'),
	Block: require('./components/flexbox/Block'),
	// Font Icon
	FontIcon: require('./components/font-icon/FontIcon'),
	// Buttons
	FlatButton: require('./components/buttons/flat-button/FlatButton'),
	FlatSplitButton: require('./components/buttons/flat-button/FlatSplitButton'),
	RaisedButton: require('./components/buttons/raised-button/RaisedButton'),
	RaisedSplitButton: require('./components/buttons/raised-button/RaisedSplitButton'),
	IconButton: require('./components/buttons/icon-button/IconButton'),
	// StickyHeader
	StickyHeader: require('./components/sticky-header/StickyHeader'),
	Header: require('./components/sticky-header/Header'),
	// List
	ListContainer: require('./components/list/ListContainer'),
	ListItem: require('./components/list/ListItem'),
	// Cards
	FancyCard: require('./components/cards/fancy-card/FancyCard'),
	// Dialog
	Dialog: require('./components/dialog/Dialog'),
	// FlashMessage
	FlashMessage: require('./components/flash-message/FlashMessage'),
	FlashContainer: require('./components/flash-message/FlashContainer'),
	// Off Canvas
	OffCanvas: require('./components/off-canvas/OffCanvas'),
	// Forms
	Input: require('./components/forms/input/Input'),
	Checkbox: require('./components/forms/checkbox/Checkbox'),
	RadioGroup: require('./components/forms/radio-group/RadioGroup'),
	Radio: require('./components/forms/radio/Radio'),
	EnhancedTextarea: require('./components/forms/enhanced-textarea/EnhancedTextarea'),
	TextField: require('./components/forms/text-field/TextField'),
	EnhancedSwitch: require('./components/forms/enhanced-switch/EnhancedSwitch'),
	Toggle: require('./components/forms/toggle/Toggle'),
	Slider: require('./components/forms/slider/Slider'),
	// Navbar
	Navbar: require('./components/navbar/Navbar'),
	NavLink: require('./components/navbar/NavLink'),
	NavDropDown: require('./components/navbar/NavDropDown'),
	NavMenu: require('./components/navbar/NavMenu'),
	// Toolbar
	Toolbar: require('./components/toolbar/Toolbar'),
	ToolbarGroup: require('./components/toolbar/ToolbarGroup'),
	// Menu
	Menu: require('./components/menu/Menu'),
	MenuItem: require('./components/menu/MenuItem'),
	// Snackbar
	Snackbar: require('./components/snackbar/Snackbar'),
	// Autocomplete
	Autocomplete: require('./components/autocomplete/Autocomplete'),
	// Transition
	Transition: require('./components/transition-groups/Transition'),
	// Codeblock
	CodeBlock: require('./components/codeblock/Codeblock'),
	// Tooltip
	Tooltip: require('./components/tooltip/Tooltip'),
	// Progress Bar
	ProgressBar: require('./components/progress-bar/ProgressBar'),
	// Divider
	Divider: require('./components/divider/Divider'),
	// Chips
	Chips: require('./components/chips/Chips'),
	// DatePicker
	DatePicker: require('./components/date-picker/DatePicker'),	
	// Tabs
	Tab: require('./components/tabs/Tab'),
	Tabs: require('./components/tabs/Tabs'),
	// Table
	Table: require('fixed-data-table').Table,
	Column: require('fixed-data-table').Column,
	ColumnGroup: require('fixed-data-table').ColumnGroup,
	// Charts
	Charts: {
		BarChart: require('./charts/bar-chart/BarChart'),
		Chord: require('./charts/chord/Chord'),
		Donut: require('./charts/donut/Donut'),
		Heatmap: require('./charts/heatmap/Heatmap'),
		Highrise: require('./charts/highrise/Highrise'),
		Multiline: require('./charts/multiline/Multiline'),
		RadialClock: require('./charts/radial-clock/RadialClock'),
		SparkBar: require('./charts/sparkbar/SparkBar'),
		SparkLine: require('./charts/sparkline/SparkLine')
	}
};



/** WEBPACK FOOTER **
 ** ./src/index.js
 **/